import { render, staticRenderFns } from "./projectTypeList.vue?vue&type=template&id=9e850bac&"
import script from "./projectTypeList.vue?vue&type=script&lang=js&"
export * from "./projectTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports